// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.container__f53 {
  position: relative;
  display: flex;
  flex-direction: column;
  gap: calc(var(--ring-unit) * 3.25);
  border: 1px solid var(--ring-line-color);
  border-radius: var(--ring-border-radius);
  background-color: var(--ring-sidebar-background-color);
  padding: calc(var(--ring-unit) * 2.75) calc(var(--ring-unit) * 4);
  min-width: 722px;

  &:after {
    content: '';
    position: absolute;
    top: -1px;
    right: -1px;
    left: -1px;
    bottom: -1px;

    border: 2px solid transparent;
    transition: border-color ease 0.3s;
    border-radius: inherit;

    pointer-events: none;
  }

  &.focused__c1c:after {
    border-color: var(--ring-main-color);
  }
}

.headerContainer__dd1 {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.actionsContainer__bbd {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: calc(var(--ring-unit) * 2.5);
}

.titleContainer__ff7 {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: calc(var(--ring-unit) * 2);
}

.badge__ab5 {
  color: var(--ring-warning-color);
  background-color: var(--ring-warning-background-color);
}
`, "",{"version":3,"sources":["webpack://./src/modules/ai/ai-settings-form/sections/ai-configuration/common/provider-form-wrapper/provider-form-base.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,kCAAkC;EAClC,wCAAwC;EACxC,wCAAwC;EACxC,sDAAsD;EACtD,iEAAiE;EACjE,gBAAgB;;EAEhB;IACE,WAAW;IACX,kBAAkB;IAClB,SAAS;IACT,WAAW;IACX,UAAU;IACV,YAAY;;IAEZ,6BAA6B;IAC7B,kCAAkC;IAClC,sBAAsB;;IAEtB,oBAAoB;EACtB;;EAEA;IACE,oCAAoC;EACtC;AACF;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,iCAAiC;AACnC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,+BAA+B;AACjC;;AAEA;EACE,gCAAgC;EAChC,sDAAsD;AACxD","sourcesContent":[".container {\n  position: relative;\n  display: flex;\n  flex-direction: column;\n  gap: calc(var(--ring-unit) * 3.25);\n  border: 1px solid var(--ring-line-color);\n  border-radius: var(--ring-border-radius);\n  background-color: var(--ring-sidebar-background-color);\n  padding: calc(var(--ring-unit) * 2.75) calc(var(--ring-unit) * 4);\n  min-width: 722px;\n\n  &:after {\n    content: '';\n    position: absolute;\n    top: -1px;\n    right: -1px;\n    left: -1px;\n    bottom: -1px;\n\n    border: 2px solid transparent;\n    transition: border-color ease 0.3s;\n    border-radius: inherit;\n\n    pointer-events: none;\n  }\n\n  &.focused:after {\n    border-color: var(--ring-main-color);\n  }\n}\n\n.headerContainer {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n}\n\n.actionsContainer {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: calc(var(--ring-unit) * 2.5);\n}\n\n.titleContainer {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: calc(var(--ring-unit) * 2);\n}\n\n.badge {\n  color: var(--ring-warning-color);\n  background-color: var(--ring-warning-background-color);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `container__f53`,
	"focused": `focused__c1c`,
	"headerContainer": `headerContainer__dd1`,
	"actionsContainer": `actionsContainer__bbd`,
	"titleContainer": `titleContainer__ff7`,
	"badge": `badge__ab5`
};
export default ___CSS_LOADER_EXPORT___;
